<template>
  <div>
    <div class="mails timeline" v-if="myMails.length > 0">
      <b-row v-for="mail in myMails" :key="mail.id">
        {{ getStatut(mail) }}
        <b-col cols="10" class="mails-history text-right">
          <b-card class="card-timeline ">
            <b-card-body class="no-padding">
              <div class="state">
                <b-tooltip :target="'mail-' + mail.id" triggers="hover">
                  <span>{{ getText(mail.status) }}</span>
                </b-tooltip>
                <span
                  :class="'container-icon ' + mail.status"
                  :id="'mail-' + mail.id"
                >
                  <font-awesome-icon
                    :icon="getIcon(mail.status)"
                  ></font-awesome-icon>
                </span>
              </div>
              <div class="body">
                <div class="context">
                  {{ mail.context }}
                </div>
                <div class="date text-right">
                  {{ mail.createdAt }}
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="2" class="img-history">
          <div v-if="mail.stdUser.picture" class="avatar-profil">
            <div class="container-avatar">
              <div class="profil">
                <b-img
                  class="img-circle"
                  :id="'img-circle-' + mail.id"
                  img
                  :src="mail.stdUser.picture"
                  alt="user-img"
                />
                <b-tooltip :target="'img-circle-' + mail.id" triggers="hover">
                  <span>{{ mail.stdUser.email }}</span>
                </b-tooltip>
              </div>
            </div>
          </div>
          <div v-else class="avatar-profil">
            <div class="container-avatar">
              <div class="profil">
                <b-img
                  :id="'img-circle-' + mail.id"
                  class="img-circle"
                  img
                  src="../img/avatar-client.png"
                  alt="user-img"
                />
                <b-tooltip :target="'img-circle-' + mail.id" triggers="hover">
                  <span>{{ mail.stdUser.email }}</span>
                </b-tooltip>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      Pas d'historique disponible.
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

export default {
  name: "History",
  components: {},
  computed: {
    myMails: {
      get() {
        return this.mails;
      },
      set(value) {
        this.setMails(value);
      },
    },
    ...Vuex.mapGetters("Log", ["mails"]),
  },
  data: () => ({}),
  watch: {
    id: {
      deep: true,
      handler: function(val, oldVal) {
        this.getLogMails(val);
      },
    },
  },
  mounted() {
    this.getLogMails(this.id);
  },
  props: {
    id: { type: String, required: false, default: null },
  },
  methods: {
    getText(text) {
      let msg = "Inconnu";
      switch (text) {
        case "unknown":
        case "bounce":
        case "hardbounced":
        case "softbounced":
          msg = "Une erreur est survenue lors de l'envoi du mail";
          break;
        case "queued":
          msg = "Le mail est en attente d'envoi";
          break;
        case "sent":
          msg = "Le mail a été délivré";
          break;
        case "opened":
          msg = "Le mail a été ouvert";
          break;
        case "clicked":
          msg = "Le mail a été cliqué";
          break;
        case "spam":
          msg = "Le mail est dans les SPAM";
          break;
        case "unsub":
          msg = "Le mail n'a pas été envoyé car la personne s'est désinscrite";
          break;
        case "blocked":
          msg = "Le mail a été bloqué";
          break;
        case "deferred":
          msg = "Le mail est en cours de renvoi";
          break;
      }
      return msg;
    },
    getIcon(text) {
      let icon = "";
      switch (text) {
        case "unknown":
        case "bounce":
        case "hardbounced":
        case "softbounced":
          icon = "times";
          break;
        case "queued":
          icon = "clock";
          break;
        case "sent":
          icon = "check";
          break;
        case "opened":
          icon = "envelope-open";
          break;
        case "clicked":
          icon = "mouse-pointer";
          break;
        case "spam":
          icon = "ban";
          break;
        case "unsub":
          icon = "reply";
          break;
        case "blocked":
          icon = "ban";
          break;
        case "deferred":
          icon = "send";
          break;
      }
      return icon;
    },
    getStatut(mail) {
      fetch(
        "https://www.clicmap.fr/silex/ads_dev-hu.php/api/mailjet/message/" +
          mail.mailjetId
      )
        .then((res) => res.json())
        .then((res) => {
          mail.status = res.Status;
        });
    },
    ...Vuex.mapActions("Log", ["getLogMails", "setMails"]),
  },
};
</script>

<style></style>
